<div   class="mb-54 mct-flex mct-row mct-justify-around mct-items-stretch">
  <button pButton type="button" class="atlas-btn atlas-btn-primary" data-cy="login-link" data-testid="login-link" (click)="login()">
    {{ 'shared.container.unauthenticated.component.sign-in-label' | translate | uppercase }}
  </button>
</div>
